export enum ChatMessageTypesEnum {
  File = 'FILE',
  Text = 'CHAT',
  ConsultationsHistory = 'CONSULTATIONS_HISTORY',
  UserTyping = 'USER_TYPING',
  ChatFile = 'chat_file',
  DiscussionFile = 'discussion_file'
}
